import React from 'react';
import { StyleSheet } from 'react-native';
import { DNABox, DNACard, DNAText, useTheme, util } from '@alucio/lux-ui';
import { DNAChip, DNAPopover, DNACustomDeckThumbnail } from 'src/components/DNA';
import { FolderItemORM, CustomDeckORM } from 'src/types/types';
import { DNARowsComponent } from 'src/components/DNA/FlatList/Rows/types';

const styles = StyleSheet.create({
  cardStyle: {
    backgroundColor: 'transparent',
  },
  titleText: {
    marginLeft: 24,
    paddingRight: 16,
  },
  popoverAnchor: {
    flex: 1,
    flexDirection: 'column',
    width: '100%',
  },
})

const DNACustomDeckFolderItemCustomDeckRow: DNARowsComponent<FolderItemORM> = (props) => {
  const {
    ORM: folderItem,
    onPress,
    isOnline,
  } = props

  const theme = useTheme()

  const customDeckORM = (folderItem.relations.itemORM as CustomDeckORM)
  const {
    containsWebDocs,
    assets:{ isContentCached },
  } = customDeckORM.meta
  const contentAvailable = isOnline || (isContentCached && !containsWebDocs)

  const allStyle = {
    paddingHorizontal: theme['row-padding-horizontal'],
    paddingVertical: theme['row-padding-vertical'],
  }

  const popoverInfoText = 'Modified files cannot be used when building presentations'

  return (
    <DNACard
      appearance="flat"
      disabled={true}
      onPress={() => onPress?.(folderItem)}
      style={[util.mergeStyles(props, allStyle, styles.cardStyle)]}
    >
      <DNAPopover disablePopover={['tabletPWA']} placement="top">
        <DNAPopover.Anchor style={styles.popoverAnchor}>
          <DNABox
            fill
            testID="folder-item-row"
            alignY="center"
            style={{ opacity: 0.4 }}
          >
            <DNABox fill alignY="center">
              {/* Thumbnail */}
              <DNABox>
                <DNACustomDeckThumbnail.Hover
                  customDeckORM={customDeckORM}
                  width={120}
                  height={68}
                  unavailableContent={!contentAvailable}
                />
              </DNABox>
              <DNABox fill appearance="col" spacing="sm" style={styles.titleText}>
                {/* Title */}
                <DNAText testID="document-item-title" b1 numberOfLines={3}>
                  {folderItem.meta.title}
                </DNAText>
                {/* Badge & Tags */}
                <DNABox
                  fill
                  appearance="row"
                  spacing="sm"
                  alignY="center"
                  childStyle={[4, { flex: 1 }]}
                >
                  <DNAChip.Beacon variant="MODIFIED" />
                </DNABox>
              </DNABox>
            </DNABox>
          </DNABox>
        </DNAPopover.Anchor>
        <DNAPopover.Content>
          <DNAText colorMode="dark">{popoverInfoText}</DNAText>
        </DNAPopover.Content>
      </DNAPopover>
    </DNACard>
  )
}

export default DNACustomDeckFolderItemCustomDeckRow
